import React, { useState, useEffect } from "react";
import "../Create/Background.css";

function BackgroundView(props) {
  const [DivStyle, SetDivStyle] = useState({
    position: "absolute",
    left: document.body.clientWidth  / 2 - 150,
    height: 300,
    width: 300,
    marginTop: "50px",
    backgroundColor: props.BackgroundColor
  });
  const [InnerWidth, SetInnerWidth] = useState(document.body.clientWidth);
  const [backCover, setBackCover] = useState({});
  const [topCover, setTopCover] = useState({});
  const [rightCover, setRightCover] = useState({});
  const [bottomCover, setBottomCover] = useState({});
  const [leftCover, setLeftCover] = useState({});
  const [marginTop, setMarginTop] = useState(100)

  useEffect(() => {
    function CheckStyle() {
      //alert('change something')

      SetDivStyle({
        position: "absolute",
        //margin: "0 auto",
        height: "300px",
        width: "300px",
        top: marginTop,
        left: document.body.clientWidth / 2 - 150,
        //marginLeft: "50vw",
        //left: "-25vh",
        backgroundColor: props.BackgroundColor,
        //backgroundColor: "#ffffff",
        touchAction: "none",
        zIndex: 0
      });
      setTopCover({
        position: "absolute",
        left: "0",
        top: 0,
        height: marginTop,
        width: "100%",
        backgroundColor: "#3b4652",
        zIndex: 2
      });
      setLeftCover({
        position: "absolute",
        left: "0",
        top: "0",
        height: "100%",
        width: document.body.clientWidth / 2 - 150 + "px",
        backgroundColor: "#3b4652",
        zIndex: 2
      });
      setRightCover({
        position: "absolute",
        left: document.body.clientWidth / 2 + 150,
        top: "0",
        height: "100%",
        width: document.body.clientWidth / 2 - 150,
        backgroundColor: "#3b4652",
        zIndex: 2
      });
      setBottomCover({
        position: "absolute",
        left: 0,
        top: marginTop + 300,
        width: "100%",
        minHeight: '100%',//window.innerHeight - 300,
        backgroundColor: "#3b4652",
        zIndex: 2
      });
    }
    CheckStyle();
    window.addEventListener("resize", CheckStyle);
  }, [props.BackgroundColor]);

  return (
    <div>
      <img
        src={props.product.PictureUrl1}
        style={{
          position: "absolute",
          left: DivStyle.left,
          top: DivStyle.top,
          height: DivStyle.height,
          height: DivStyle.height,
          marginLeft: DivStyle.marginLeft,
          marginTop: DivStyle.marginTop,
          zIndex: 0
        }}
      />

      <div style={DivStyle}></div>

      <img
        src={props.product.PictureUrl2}
        style={{
          position: "absolute",
          left: DivStyle.left,
          top: DivStyle.top,
          height: DivStyle.height,
          height: DivStyle.height,
          marginLeft: DivStyle.marginLeft,
          marginTop: DivStyle.marginTop,
          zIndex: 2
        }}
      />

      <div style={topCover} className="topCover"></div>
      <div style={rightCover} className="rightCover"></div>
      <div style={bottomCover} className="bottomCover"></div>
      <div style={leftCover} className="leftCover"></div>
    </div>
  );
}

export default BackgroundView;
